import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ComponentDesignTimestamps } from '@paragon/contract-library';
import { projectSynchronized } from '@paragon/layout-models';

export interface ComponentDesignTimestampsState {
  readonly [componentDesignGuid: string]: ComponentDesignTimestamps | undefined;
}

const initialState: ComponentDesignTimestampsState = {};

export const componentDesignTimestampsSlice = createSlice({
  name: 'componentDesignTimestamps',
  initialState,
  reducers: {
    componentDesignTimestampsLoaded: (state, action: PayloadAction<readonly ComponentDesignTimestamps[]>) => {
      for (const componentDesignTimestamps of action.payload) {
        state[componentDesignTimestamps.componentDesignGuid] = componentDesignTimestamps;
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(projectSynchronized, (state, action) => {
      for (const syncPayload of Object.values(action.payload)) {
        for (const incomingTimestamp of syncPayload.incomingTimestamps) {
          state[incomingTimestamp.componentDesignGuid] = incomingTimestamp;
        }
      }
    });
  },
});

export const { componentDesignTimestampsLoaded } = componentDesignTimestampsSlice.actions;
export const componentDesignTimestamps = componentDesignTimestampsSlice.reducer;
